import { selector } from './selector';
import * as events from "./events";

const PageRegisterTagFormTasMK = (function ($) {

    function checkTerms() {
        $(selector.btn.submit).prop('disabled', !$(selector.checkTerms).is(':checked'));
        $(document).on('change', selector.form.customerType, events.toggleCustomerType);
        $(document).on('change', selector.form.tagType, events.toggleTagType);
    }

    function initEvents() {

    }

    function initialize() {
        initEvents();
        setInterval(checkTerms, 500);

        $(document).on('submit', selector.form.main, function (e) {
            const $submitBtn = $(selector.btn.submit);
            $submitBtn.prop('disabled', true);
            $submitBtn.addClass('disabled');
        });
    }

    return {
        init: initialize
    }
})(jQuery);

export { PageRegisterTagFormTasMK };